(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["j-article-with-header"] && !Shopify.designMode) return;
  try {
    
    $(document).ready(function () {
    $(".mobile-list-news").slick({
      rtl: false,
      dots: false,
      infinite: true,
      speed: 300,
      autoplay: true,
      arrows: true,
      slidesToShow: 1
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["j-collection-link-2"] && !Shopify.designMode) return;
  try {
    
    $(document).ready(function () {
    $(".collection-page-item-mobile-two").slick({
      rtl: false,
      dots: true,
      infinite: true,
      speed: 300,
      autoplay: true,
      arrows: true,
      slidesToShow: 1,
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["j-collection-link-3"] && !Shopify.designMode) return;
  try {
    
    $(document).ready(function () {
    $(".collection-page-item-mobile-three").slick({
      rtl: false,
      dots: true,
      infinite: true,
      speed: 300,
      autoplay: true,
      arrows: true,
      slidesToShow: 1,
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["j-collection-link"] && !Shopify.designMode) return;
  try {
    
    $(document).ready(function () {
    $(".collection-page-item-mobile").slick({
      rtl: false,
      dots: true,
      infinite: true,
      speed: 300,
      autoplay: true,
      arrows: true,
      slidesToShow: 1,
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["j-multi-videos"] && !Shopify.designMode) return;
  try {
    
    $(document).ready(function () {
    $(".video-list-mobile").slick({
      rtl: false,
      dots: false,
      infinite: true,
      speed: 300,
      autoplay: true,
      arrows: true,
      slidesToShow: 1,
    });
  });

  } catch(e) { console.error(e); }
})();
})();
